export const hasErrorCode = <const C extends string>(error: unknown, code: C): error is { errorCode: C } =>
  typeof error === "object" && error !== null && "errorCode" in error && error.errorCode === code;
